module.exports = "<div [ngSwitch]=\"step | async\">\n        <itpx-instructor-grid  *ngSwitchCase=\"state.Email\" [productGroupId]=\"data.groupId\" (details)=\"onInstructorEdit($event)\"></itpx-instructor-grid>\n        <itpx-edit-details *ngSwitchCase=\"state.Create\" [instructor]=\"instructor\" [step]=\"step\" (details)=\"onSecondStepSubmit()\"></itpx-edit-details>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/solar/classes/components/wizard/class-instructor/edit-instructor/edit-instructor.component.html
// module id = ./src/app/solar/classes/components/wizard/class-instructor/edit-instructor/edit-instructor.component.html
// module chunks = main